// extracted by mini-css-extract-plugin
export default {"loading":"search_loading__03Ju5","pcWrap":"search_pcWrap__oIEFn","footer":"search_footer__4ELpM","footerGap":"search_footerGap__woHxk"};